import React from "react";

import "./Header.css";

import Logo from "../Images/Logo.webp";
import HeaderBG from "../Images/HeaderBG.webp"
import { Link } from "react-scroll";
import Navbar from "../Navbar/Navbar";
import Popup from "../Popup/Popup";

function Header() {
  
  return (
    <header id="header" style={{backgroundImage: `url(${HeaderBG})`}}>
            {/* <div className="nav__upsale">
              <span className="upsale__text">WELCOME BOOK A FREE 15 MINUTE CONSULTATION </span> <Link to="enquire" smooth={true} duration={800} className="upsale__button">
               TODAY
            </Link>
            </div> */}

            

       <Navbar 
      main={true}/>

     

      <div className="row header__row" >
 <Popup main={true}/>

        <div className="header__text ">
       
          <h1 className="header__title">
          FIND<br/><span className="tab">YOUR</span><br/>BLISS
          </h1>
          
          <div className="header__text__links">
          <Link to="services" smooth={true} duration={800} className="header__button">
              START TODAY
            </Link>
          </div>
        </div>
        <img src={Logo} alt="" className="header__image"/>
        
      </div>
      <div className="fade"></div>
    </header>
  );
}

export default Header;
